import React, { Component } from "react";
import Tabs from '../../../../../tabs/Tabs';
import {FieldGroupContext} from "../../../../../contexts/FieldGroupContext";
import Ordering from "../DisplayData/Ordering";
import OffsetLimit from "../DisplayData/OffsetLimit";
import TableSelection from "./TableSelection";
import DefaultFieldsFilter from "../DisplayCustomTable/DefaultFieldsFilter";
import Output from "../DisplayCustomTable/Output";

export const DisplayCustomTable = (props) => {

	return(
		<div id="poststuff" className="display-data-box">
			<div id="slugdiv" className="postbox">
				<h2 className="hndle ui-sortable-handle"><span>Display Custom Table</span></h2>
				<div className="inside" style={{display: 'block'}}>

					<p>This action should be used whenever you want to output data from custom database tables.</p>

						{props.endpoint.displayCustomTable && props.endpoint.displayCustomTable.map(
							(el, index) =>

									<FieldGroupContext.Provider key={index} value={{
										action: 'displayCustomTable',
										currentItem: index,
										endpointId: props.id,
										endpoint: props.endpoint
									}}>

									<Tabs tabs={[
										{
											name:    'tableSelection',
											title:   'Table Selection',
											enabled: true,
											content: <TableSelection group={'tableSelection'} key={index + '-tableSelection'}/>
										},
										{
											name:    'defaultFields',
											title:   'Filter Columns',
											enabled: true,
											content: <DefaultFieldsFilter group={'defaultFields'} key={index + '-defaultFields'}/>
										},
										{
											name: 'orderby',
											title: 'Ordering',
											enabled: true,
											content: <Ordering key={index + '-ordering'} action='displayCustomTable'/>
										},
										{
											name: 'limit-offset',
											title: 'Limit and Offset (Pagination)',
											enabled: true,
											content: <OffsetLimit key={index + '-limit-offset'}/>
										},
										{
											name: 'output',
											title: 'Endpoint Output',
											enabled: true,
											content: <Output key={index + '-output'} group={'output'}/>
										},
									]} />

								</FieldGroupContext.Provider>
						)}

				</div>
			</div>
		</div>
	)
};
